<template>
  <appointment-coordination
    main-page-title="Manejo de Coordinación a Evaluación"
    :main-page-routes="[
      'Inicio',
      'Estudiante',
      'Citas',
      'Manejo de Citas',
      'Coordinación de Cita',
    ]"
    :coordinate-new-space="coordinateNewSpace"
    :get-appointment-info="getAppointmentInfo"
    :get-breach="getBreach"
    :get-centerby-user-id="getCenterbyUserId"
    :get-centers="getCenters"
    :get-contact-information="getContactInformation"
    :get-municipalities-by-discipline="getMunicipalitiesByDiscipline"
    :get-phone-providers="getPhoneProviders"
    :get-registration-date="getRegistrationDate"
    :get-relationships="getRelationships"
    :get-student-detail="getStudentDetail"
    :get-valid-appointment-disciplines="getValidAppointmentDisciplines"
    :has-active-coordinated-discipline-fn="hasActiveCoordinatedDisciplineFn"
    :has-permissions="hasPermissions"
    :load-validation-messages="loadValidationMessages"
    :save-appointment-coordinate="saveAppointmentCoordinate"
    :search-available-dates="searchAvailableDates"
    :user="user"
  />
</template>

<script>
import { mapState } from 'vuex';
import { AppointmentCoordination } from 'appointment-management';
import appointmentServiceManager from '@/services/api/appointment.api.js';
import resourceServiceManager from '@/modules/common/resource.api.js';

export default {
  name: 'AppointmentCoordinationWrapper',
  components: {
    AppointmentCoordination,
  },
  computed: {
    ...mapState('$_user', ['user']),
    userInfo() {
      return {
        profile: this.userProfile,
      };
    },
  },
  methods: {
    coordinateNewSpace(clientAppointmentId) {
      this.$router.push({
        path: `/appointmentNewSpaceCoordination/${clientAppointmentId}`,
      });
    },
    hasPermissions(permission) {
      return this.$store.getters.HasPermission(permission);
    },
    getStudentDetail(studentSie) {
      return appointmentServiceManager.getStudentDetail(studentSie);
    },

    //available appointment services
    loadValidationMessages(params) {
      return resourceServiceManager.LoadValidationMessages(params);
    },
    searchAvailableDates(params) {
      return appointmentServiceManager.searchAvailableDates(params);
    },
    getValidAppointmentDisciplines(serviceTypeId) {
      return appointmentServiceManager.getValidAppointmentDisciplines(
        serviceTypeId
      );
    },
    hasActiveCoordinatedDisciplineFn(params) {
      return appointmentServiceManager.hasActiveCoordinatedDiscipline(params);
    },
    getMunicipalitiesByDiscipline(params) {
      return appointmentServiceManager.getMunicipalitiesByDiscipline(params);
    },
    getBreach(params) {
      return appointmentServiceManager.getBreach(params);
    },
    getRegistrationDate(studentId) {
      return appointmentServiceManager.getRegistrationDate(studentId);
    },

    //confirm appointment services
    getAppointmentInfo(clientAppointmentId) {
      return appointmentServiceManager.getAppointmentInfoByClientAppointmentId(
        clientAppointmentId
      );
    },
    getRelationships() {
      return appointmentServiceManager.getRelationships();
    },
    getPhoneProviders() {
      return appointmentServiceManager.getPhoneProviders();
    },
    getContactInformation(studentId) {
      return appointmentServiceManager.getContactInformation(studentId);
    },
    getCenterbyUserId(sub) {
      return appointmentServiceManager.getCenterbyUserId(sub);
    },
    getCenters() {
      return appointmentServiceManager.getCenters();
    },
    saveAppointmentCoordinate(data) {
      return appointmentServiceManager.saveAppointmentCoordinate(data);
    },
  },
};
</script>
